import React from "react";
import { useNavigate } from "react-router-dom";

/**
 * Shown in place of a CRM page's content when the backend answers 403
 * upgrade_required — the studio's plan doesn't include the CRM.
 */
function CrmUpgrade() {
  const navigate = useNavigate();
  return (
    <div className="crm-card crm-upgrade">
      <span className="crm-upgrade-icon">🤝</span>
      <h3>CRM is a Pro feature</h3>
      <p>
        Track every enquiry, send branded quotes built from your packages, and
        never miss a follow-up. The CRM is included in the <strong>Pro</strong> and{" "}
        <strong>Pro Max</strong> plans.
      </p>
      <button className="crm-btn primary" onClick={() => navigate("/wallet")}>
        See plans & upgrade
      </button>
    </div>
  );
}

export default CrmUpgrade;
